const OWNERS_TAG_TYPES = {
  OWNERS_GET_LIST: "OWNERS_GET_LIST",
  OWNERS_CREATE: "OWNERS_CREATE",
  OWNERS_EDIT: "OWNERS_EDIT",
  OWNERS_DETAIL: "OWNERS_DETAIL"
};

export const OWNERS_TAGS = Object.values(OWNERS_TAG_TYPES);
export default OWNERS_TAG_TYPES;
